<div #chartContainer style="width: 100%; height: 450px"></div>
